<section class="support-page">
  <div class="support-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1>Support</h1>
      <p>Need help with YoGamez Hub? Our team is ready to assist.</p>
    </div>
  </div>

  <div class="support-content">
    <article class="support-card">
      <h2>Customer Care</h2>
      <p>
        All queries pertaining to the service should be directed to Econet Wireless' Customer Care via various channels including calling toll free number 111 and social media pages or via email to
        <a href="mailto:enquiries@econet.co.zw">enquiries@econet.co.zw</a>.
      </p>
      <p>
        Our address for service is Econet Park, No. 2 Old Mutare Road, Msasa, Harare, Zimbabwe.
      </p>
      <p>
        Alternatively, a subscriber can seek assistance at any of the Econet franchise shops located around the country.
      </p>

      <div class="support-actions">
        <a href="tel:111" class="support-btn">Call 111</a>
        <a href="mailto:enquiries@econet.co.zw" class="support-btn alt">Email Support</a>
      </div>
    </article>
  </div>
</section>
